import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";

import AboutUs from "./lazy"

export default {
    component: AboutUs,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({
            title: allMessage["aboutus.story.h2"],
            description: allMessage["aboutus.story.p"],
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
